import { createStore } from 'vuex'
import permission from './module/permission'
import user from './module/user'
import getters from './getter'

export default createStore({
  state: {
  },
  getters,
  mutations: {
  },
  actions: {
  },
  modules: {
    permission,
    user
  }
})
